import React from 'react';

import { iconBaseProps, type IconProps } from './IconBase';

const MinusIcon: React.FC<IconProps> = props => (
  <svg {...iconBaseProps} {...props}>
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export default MinusIcon;
